















import InsectionObserveDirective from '../../directives/visible';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';

const visible = InsectionObserveDirective as unknown as any;

@Component({
    name: 'PdfThumbnailItem',
    components: {},
    directives: {
        visible
    }
})
export default class PdfThumbnailItem extends Vue {
    @Inject('doChangeDocument')
    doChangeDocument: any

    @Prop()
    document!: any;

    @Prop()
    imageBaseUrl!: string;

    @Prop(Boolean)
    isSelected!: boolean;

    get zwdt_access_token() {
        return (this as any).$route.query?.zwdt_access_token ?? '';
    }

    get imageUrl() {
        return `${(this as any).BASE_APP_PATH}${this.imageBaseUrl}?documentId=${this.document.id}&pageNo=1&_s=${Date.now()}&zwdt_access_token=${this.zwdt_access_token}`
    }

    visibility = false;

    handleVisibility(visibility: boolean) {
        this.visibility = visibility;
    }
}
